module.exports = __webpack_public_path__ + "static/privacy-4-c73bba8eddd5d318a799bbcb9dcd72f9.svg";